import { createRoot } from 'react-dom/client';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import { App } from './App';

const container = document.getElementById('root');

if (!container) {
  throw new Error('container not found!');
}
const root = createRoot(container);

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: window.env.ALERTS_LAUNCH_DARKLY_ID,
  });

  root.render(
    <LDProvider>
      <App />
    </LDProvider>
  );
})();
